var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGestao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2302 24.22L15.9565 21.02L16.8363 20.16L19.2302 22.5L24.1202 17.72L25 18.58L19.2302 24.22ZM23.7315 15.94H22.5038V11.8H21.2762V13.6H11.4552V11.8H10.2276V23.8H15.3632V25H10.2276C9.87298 25 9.57971 24.8867 9.34783 24.66C9.11594 24.4333 9 24.1467 9 23.8V11.8C9 11.4533 9.11594 11.1667 9.34783 10.94C9.57971 10.7133 9.87298 10.6 10.2276 10.6H14.3606C14.4561 10.1333 14.6914 9.75 15.0665 9.45C15.4416 9.15 15.8747 9 16.3657 9C16.8568 9 17.2899 9.15 17.665 9.45C18.0401 9.75 18.2754 10.1333 18.3708 10.6H22.5038C22.8585 10.6 23.1517 10.7133 23.3836 10.94C23.6155 11.1667 23.7315 11.4533 23.7315 11.8V15.94ZM16.3657 11.8C16.5976 11.8 16.792 11.7233 16.9488 11.57C17.1057 11.4167 17.1841 11.2267 17.1841 11C17.1841 10.7733 17.1057 10.5833 16.9488 10.43C16.792 10.2767 16.5976 10.2 16.3657 10.2C16.1338 10.2 15.9395 10.2767 15.7826 10.43C15.6257 10.5833 15.5473 10.7733 15.5473 11C15.5473 11.2267 15.6257 11.4167 15.7826 11.57C15.9395 11.7233 16.1338 11.8 16.3657 11.8Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGestao);
export default __webpack_public_path__ + "static/media/icon-gestao.67a42cf7.svg";
export { ForwardRef as ReactComponent };